<template>
	<v-container>
		<v-col class="mt-10">
			<br />
			<v-flex center xs12>
				<v-img
					contain
					aspect-ratio="3.5"
					:src="require('../assets/Sharpsmart-LogoMedium.png')"
				></v-img>
			</v-flex>
		</v-col>

		<v-form>
			<v-col class="loginArea" @keyup.enter="authFB(userEmail, userPassword)">
				<v-flex mx-4 xs12>
					<v-flex xs12>
						<v-text-field
							class="mx-8"
							label="Email Address"
							color="teal"
							v-model="userEmail"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							:append-icon="visiblePass ? 'visibility' : 'visibility_off'"
							:type="visiblePass ? 'text' : 'password'"
							v-model="userPassword"
							label="Password"
							@click:append="visiblePass = !visiblePass"
							color="teal"
							class="mx-8"
							required
						></v-text-field>
					</v-flex>
					<p style="color: red">{{ loginFeedback }}</p>
				</v-flex>
			</v-col>

			<v-col>
				<v-flex class="text-xs-center" xs12></v-flex>
			</v-col>
			<v-col>
				<v-flex class="text-xs-center" xs12>
					<v-img
						:src="require('../assets/Daniels-Trace-Login-Button.svg')"
						v-on:click="authFB(userEmail, userPassword)"
						height="75"
						contain
					></v-img>
				</v-flex>
				<v-row class="text-right">
					<v-col>
						<span>{{ versionNumber }}</span>
					</v-col>
				</v-row>
			</v-col>
		</v-form>
	</v-container>
</template>

<script>
import * as firebase from "@/firebase";
import { version } from "../../package.json";

export default {
	data() {
		return {
			userEmail: "",
			userPassword: "",
			visiblePass: false,
			loginFeedback: "",
			versionNumber: version,
		};
	},
	methods: {
		authFB(email, password) {
			email = email.trim();

			if (email !== " " && email.length > 1) {
				if (password.length > 0) {
					firebase.auth
						.signInWithEmailAndPassword(email, password)
						.then((user) => {
							let ref = firebase.db.collection("users").doc(email);
							ref.get().then((doc) => {
								if (doc.exists) {
									this.$store.commit("SET_USER", doc.data());
								} else {
									// doc.data() will be undefined in this case
									// eslint-disable-next-line
									console.log("No such document!");
								}
							});

							this.$router.push({
								name: "dashboard",
								params: { user: user.email },
							});
						})
						.catch((loginErr) => {
							this.loginFeedback = loginErr.message;
						});
				} else {
					this.loginFeedback = "Please enter your password.";
				}
			} else {
				this.loginFeedback = "Please enter your email address.";
			}
		},
		openFreshdesk() {
			let browserInfo = navigator.userAgent.toLowerCase();
			if (browserInfo.indexOf("android") > -1) {
				window.location.replace(
					"market://details?id=com.freshservice.helpdesk",
				);
			} else {
				window.open("https://danielshealth.freshservice.com/support/home");
			}
		},
	},
};
</script>

<style scoped>
.v-btn {
	padding: 7%;
	width: 40%;
	font-size: 2.25em;
}
.pointer {
	cursor: pointer;
}
</style>
